import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;

  .repositories-errorMessage {
    color: #ff2f2f;
    margin-top: -20px;
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
  }

  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      width: 130px;
    }
  }
`;
